export type MessageSegment = {
  isLink: boolean;
  value: string;
};

const LINK_PATTERN = /(https?:\/\/[^\s]+|msteams:\/\/[^\s]+)/gi;
const LINK_EXACT_PATTERN = /^(https?:\/\/[^\s]+|msteams:\/\/[^\s]+)$/i;

export const splitMessageIntoSegments = (message: string): MessageSegment[] => {
  return message.split(LINK_PATTERN).reduce((acc, part) => {
    if (part.length === 0) {
      return acc;
    }

    return [
      ...acc,
      {
        value: part,
        isLink: LINK_EXACT_PATTERN.test(part),
      },
    ];
  }, [] as MessageSegment[]);
};
